/*
| Shared select control: turns any `<select.pl-select data-combo>` into the themed
| searchable combobox (combobox.ts). Opt-in via the `data-combo` attribute so it
| never clashes with the bespoke comboboxes calendar/weekTemplates build themselves.
| Idempotent — already-enhanced selects are flagged and skipped.
*/
import { enhanceSelect } from './combobox';

export function enhanceSelects(root: ParentNode = document): void {
    root.querySelectorAll<HTMLSelectElement>('select.pl-select[data-combo]:not([data-combo-done])').forEach((select) => {
        select.dataset.comboDone = '1';
        enhanceSelect(select);
    });
}
